export const budgetAndAlertsDefaultColDef = {
  unSortIcon: true,
  flex: 1,
  filter: "agMultiColumnFilter",
  cellStyle: { cursor: "pointer" },
};
